import module from './index'

let moduleName = 'module->' + module.info.name;
const routes = [
    {
        path: module.info.name,
        name: moduleName,
        component: () => import('./View.vue'),
        children: [
            {
                path: 'create',
                name: moduleName + '->create',
                component: () => import('./create/View'),
            },
            {
                path: 'list',
                name: moduleName + '->list',
                component: () => import('./list/View'),
                children: [
                    {
                        path: ':listPage',
                        name: moduleName + '->list->page',
                        component: () => import('./list/page/View'),
                    }
                ]
            },
            {
                path: 'panel-tabs',
                name: moduleName + '->panel-tabs',
                component: () => import('./panel-tabs/View.vue'),
                children: [
                    {
                        path: ':tabName',
                        name: moduleName + '->panel-tabs->tab',
                        component: () => import('./panel-tabs/tabs/View.vue'),
                        children: [
                            {
                                path: 'list',
                                name: moduleName + '->panel-tabs->tab->list',
                                component: () => import('./testing-numbers/View'),
                                /*children: [
                                    {
                                        path: ':listPage',
                                        name: moduleName + '->panel-tabs->tab->list->page',
                                        component: () => import('./broadcast-history/page/View'),
                                    }
                                ]*/
                            }
                        ]
                    }
                ]
            },
            {
                path: ':entityTitle',
                name: moduleName + '->view',
                component: () => import('./view/View.vue'),
            }
        ]
    }
];

export default routes
